export default {"src":"/_next/static/media/exclamation_mark.17aaefe3.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};